// extracted by mini-css-extract-plugin
export default {"tab":"ProfilePage_tab__qXTPc"};